module.exports = __webpack_public_path__ + "img/pdf.45d71806.svg";